import styled from "styled-components";
import colors from "../../constants/colors";

export const Actions = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: "0.75rem",
  width: "100%",
  maxWidth: "320px",
  marginTop: "1.5rem",
});

export const IcsLink = styled("button")({
  background: "none",
  border: "none",
  color: colors.PURPLE,
  fontSize: "0.9rem",
  textDecoration: "underline",
  padding: "0.5rem 0",
  cursor: "pointer",
  fontFamily: "inherit",
});

export const Container = styled("div")({
  background: `
    radial-gradient(circle at 20% 10%, rgba(116, 105, 182, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 90%, rgba(173, 136, 198, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(225, 175, 209, 0.03) 0%, transparent 70%),
    ${colors.BACKGROUND}
  `,
  borderRadius: "15px",
  padding: "1rem",
  color: colors.BLACK,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "0.5rem",
  textAlign: "center",
  direction: "rtl",
  position: "relative",

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "200px",
    background: `linear-gradient(180deg, rgba(116, 105, 182, 0.03) 0%, transparent 100%)`,
    borderRadius: "15px 15px 0 0",
    pointerEvents: "none",
    zIndex: 0,
  },

  "& > *": {
    position: "relative",
    zIndex: 1,
  },
});
